import { Component, OnInit, ViewChild } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
import { Common, ContentCriteria, ContentStatus } from 'src/app/common';

@Component({
  selector: 'app-manage-content',
  templateUrl: './manage-content.component.html',
  styleUrls: ['./manage-content.component.scss']
})
export class ManageContentComponent implements OnInit {
  Common = Common;

  constructor(private contentService: ContentService, private spinner: SpinnerService) { }

  contents: any[];
  total: number;
  criteria = new ContentCriteria();
  status = ContentStatus.None;
  selected: any = {};
  limit = 50;
  image: File;
  preview: string | ArrayBuffer;
  imageUrl = environment.app.filesUrl;

  @ViewChild('contentModal') contentModal: NgxSmartModalComponent;

  async ngOnInit() {
    await this.load();
  }

  async load(page: { from: number, limit: number } = { from: 0, limit: this.limit }) {
    this.spinner.show();
    this.criteria.Statuses = (this.status == ContentStatus.None) ? [] : [this.status];
    const result = await this.contentService.getList(this.criteria, page.from, page.limit);
    this.contents = result.contents;
    this.total = result.total;
    this.spinner.hide();
  }

  openModal(content?: any) {
    this.selected = Object.assign({}, content || {
      Keywords: [],
      Status: ContentStatus.Draft
    });
    this.contentModal.open();
  }

  async delete(id: string) {
    if (!confirm('مطمئن هستید؟')) { return; }
    this.spinner.show('action');
    await this.contentService.delete(id);
    this.spinner.hide('action');
    await this.load();
  }

  addTag(term) { return term; }

  loadImage(image: File) {
    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = () => this.preview = reader.result;
    this.image = image;
  }
  removeImage(element: HTMLInputElement) {
    delete this.preview;
    delete this.image;
    delete this.selected.Image;
    element.value = '';
  }

  async save() {
    this.spinner.show('action');
    await this.contentService.save(this.selected, this.image);
    delete this.preview;
    delete this.image;
    this.spinner.hide('action');
    this.contentModal.close();
    await this.load();
  }
}
